//import { PnkAjax } from '../api/pnk-ajax';
import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

export function LoginUser(store, userObj, successFunc) {
    //code for further validations
    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('crm/login/json').ExtraData(userObj).AttachLoader(loader).OnSuccess(successFunc).Do();
}
